import type { StatusOption } from '@/Ship/Components/UI/StatusBadge/StatusBadge'

type StatusMap = Record<string, { label: string; color: string }>

/** Опція для Ship StatusBadge з мапи статусів контейнера; невідомий статус → undefined */
export const statusOption = (map: StatusMap, value: string | null | undefined): StatusOption | undefined => {
    if (!value) return undefined
    const info = map[value]
    return info ? { value, label: info.label, color: info.color } : undefined
}
